import { Headset, Lock, ShieldCheck } from 'lucide-react';

const BENEFITS = [
  {
    icon: Lock,
    label: 'Seus dados protegidos com segurança e privacidade',
  },
  {
    icon: ShieldCheck,
    label: 'Profissionais qualificados e verificados',
  },
  {
    icon: Headset,
    label: 'Suporte humanizado sempre que precisar',
  },
] as const;

export function LandingBenefits() {
  return (
    <section id="beneficios" className="scroll-mt-20 bg-teal-50/80">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-10 sm:px-6 md:grid-cols-3 lg:px-8">
        {BENEFITS.map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-start gap-3">
            <span className="mt-0.5 inline-flex size-10 shrink-0 items-center justify-center rounded-full bg-white text-teal-700 shadow-sm">
              <Icon className="size-5" aria-hidden />
            </span>
            <p className="text-sm font-medium leading-snug text-neutral-800">{label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
